import React from 'react';
import { AddCode, Attachments, DateOfVisit, Submit } from '~/components/Patient';
import { enumValue, gapShouldShowControl } from '~/util';

interface AttestationControlsProps {
    patient: PatientType;
    submission: PatientSubmissionType | null;
    setStatus: (page: string, status: number) => void;
    status: number;
    externalUpload?: ExternalAttachmentType | null;
    clearExternalUpload: () => void;
    loading: boolean;
    setLoading: (x: boolean) => void;
    uploads: MediaFileType[];
}
export function AttestationControls({
    status,
    setStatus,
    patient,
    submission,
    loading,
    setLoading,
    uploads,
    externalUpload = null,
    clearExternalUpload,
}: AttestationControlsProps) {
    return gapShouldShowControl(status) ? (
        <div className="row mb-3">
            <div className="col">
                <DateOfVisit patientId={patient.id} submission={submission} disabled={loading} />
                <div className="d-lg-none mt-2">
                    <AddCode patientId={patient.id} setStatus={setStatus} disabled={loading} />
                </div>
            </div>
            <div className="col text-end">
                <div className="me-3 d-none d-lg-inline">
                    <AddCode patientId={patient.id} setStatus={setStatus} disabled={loading} />
                </div>
                <div className="me-lg-3 mb-2 mb-lg-0 d-block d-lg-inline">
                    <Attachments
                        gapType={enumValue(['gap', 'type', 'Risk Gap']) as number}
                        patientId={patient.id}
                        patientName={`${patient.first_name} ${patient.last_name}`}
                        uploads={uploads}
                        disabled={loading}
                        externalUpload={externalUpload}
                        clearExternalUpload={clearExternalUpload}
                    />
                </div>
                <Submit
                    submission={submission}
                    patient={patient}
                    attachments={uploads}
                    handleLoading={setLoading}
                    disabled={loading}
                />
            </div>
        </div>
    ) : null;
}
